export default "__VITE_ASSET__EHde92NK__"